<template>
  <autocomplete
    v-model="selectedCompanies"
    :items="items"
    :label="$t('select_company')"
    :item-text="(item) => toLatin(item.name)"
    item-value="id"
    selectable-all
    clearable
    color="white"
    :hide-details="hideDetails"
    chips
    return-object
    deletable-chips
    multiple
    prepend-item
  >
    <template v-slot:prepend-item>
      <v-list-item
        @click="toggleAllCompanies"
        style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"
      >
        <v-list-item-action>
          <v-checkbox :value="selectedCompanies.length === items.length"></v-checkbox>
        </v-list-item-action>
        <v-list-item-title>
          {{ $t("display_all") }}
        </v-list-item-title>
      </v-list-item>
    </template>
  </autocomplete>
</template>

<script>
import { h } from 'vue';

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleAllCompanies() {
      if (this.selectedCompanies.length) {
        this.selectedCompanies = [];
      } else {
        this.selectedCompanies = this.items;
      }
    },
  },
  computed: {
    selectedCompanies: {
      get() {
        return this.$store.state.report.selectedFoodCompanies;
      },
      set(val) {
        this.$store.commit("report/SET_SELECTED_FOOD_COMPANIES", val);
      },
    },
    selectedCompaniesProxy: {
      get() {
        return this.selectedCompanies;
      },
      set(val) {
        this.selectedCompanies = val;
      },
    },
    restaurantId() {
      return this.$store.state.restaurant.id;
    },
    filters() {
      return this.$store.state.report.filters;
    },
  },
  watch: {
    items: {
      handler(newItems) {
        if (newItems.length > 0 && !this.selectedCompanies.length) {
          this.selectedCompanies = [newItems[0]];
        }
      },
      immediate: true,
    },
  },
};
</script>
